<template>
  <WdsText class="tw-truncate" :text="date" :sub-text="userName" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const HireCreatedColumn = graphql(`
  fragment HireCreatedColumn on Hire {
    id
    createdAt
    user {
      id
      name
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireCreatedColumn> }>()
const column = computed(() => useFragment(HireCreatedColumn, props.row))
const { date } = useDate(column.value.createdAt)
const userName = computed(() => column.value.user?.name ?? 'Unknown')
</script>
